import { ColorLabelInputType } from "./ColorLabelsTypes";

function ColorLabel({ color, text, font_size }: ColorLabelInputType) {
  return (
    <div className="flex flex-row mb-1.5">
      <div
        className="mt-1 py-2 px-5 max-w-2 max-h-1"
        data-testid="color-swatch"
        style={{
          backgroundColor: color,
          borderRadius: 5,
        }}
      ></div>
      <span
        style={{
          fontSize: font_size ? font_size : 24,
        }}
        className="self-center font-medium ml-3"
      >
        {text}
      </span>
    </div>
  );
}

export default ColorLabel;
